module.exports = __webpack_public_path__ + "img/bim (5).ab842972.png";